import React from 'react';
import { grey } from '@mui/material/colors';
import { FormCheckbox } from 'components/form';
import { Stack, Typography } from '@mui/material';

interface Props {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export const MyCalendars = ({ checked, onChange }: Props) => {
  return (
    <Stack gap="0.5rem" padding="0.5rem" borderRadius="0.5rem" border={`1px solid ${grey[200]}`}>
      <Typography variant="subtitle2" color="text.secondary">
        My Calendars
      </Typography>

      <FormCheckbox
        label={
          <Typography variant="body2" noWrap>
            My calendar
          </Typography>
        }
        checked={checked}
        onChange={(_, value) => onChange(value)}
      />
    </Stack>
  );
};
